module.exports = __webpack_public_path__ + "static/media/cahli_logo.4730b144.png";